
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b468152753 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1087353103 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1400585691 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b365449300 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b2078342333 = pluralGeneratorFn(function(n
) {
  return 'other';
});
Globalize.a103904016 = messageFormatterFn((function(  ) {
  return function(d) { return "Du lịch: Khách sạn, nơi lưu trú, nhà và căn hộ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1254479256 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã áp dụng điểm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2117838219 = messageFormatterFn((function(  ) {
  return function(d) { return "Không áp dụng điểm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a742821199 = messageFormatterFn((function(  ) {
  return function(d) { return "Đóng cửa sổ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1729209746 = messageFormatterFn((function(  ) {
  return function(d) { return "Đến"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b889474456 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhận phòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b963356103 = messageFormatterFn((function(  ) {
  return function(d) { return "Trả phòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1577636902 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn ngày"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b696687536 = messageFormatterFn((function(  ) {
  return function(d) { return "Khách"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a253611958 = messageFormatterFn((function(  ) {
  return function(d) { return "Tìm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a198371136 = messageFormatterFn((function(  ) {
  return function(d) { return "Thông tin khác về " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a548264797 = messageFormatterFn((function(  ) {
  return function(d) { return "Mở " + d["0"] + " trong tab mới. Nếu muốn tiếp tục, quay về tab cũ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1496070792 = messageFormatterFn((function(  ) {
  return function(d) { return "Kết quả tìm kiếm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2086490345 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng chọn một điểm đến"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a14052911 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng chọn ngày nhận phòng hợp lệ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a104212592 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn ngày cho chuyến đi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a570551702 = messageFormatterFn((function(  ) {
  return function(d) { return "Ngày trả phòng phải sau ngày nhận phòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2137777762 = messageFormatterFn((function(  ) {
  return function(d) { return "Ngày trả phòng chỉ được cách ngày nhận phòng tối đa 28 ngày"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a525232894 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng chọn ngày trả phòng hợp lệ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1036413420 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng chọn số khách"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1840916299 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng cho biết tuổi của trẻ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a750233093 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng cho biết tuổi của trẻ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a284948771 = messageFormatterFn((function(  ) {
  return function(d) { return "Ngày lưu trú phải nằm trong thời gian chuyến đi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b297491576 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b499849638 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["0"]) + " phòng";} }) + ", " + plural(d["1"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["1"]) + " khách";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1782554794 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["1"]) + " khách";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b335563448 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["1"]) + " khách";} }) + ", vật nuôi"; }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.a367945255 = messageFormatterFn((function(  ) {
  return function(d) { return "Khách"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1942791685 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã thêm phòng " + d["0"] + ". Chỉnh sửa thông tin khách bên dưới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2075243749 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã xóa phòng. Chỉnh sửa thông tin khách phòng " + d["0"] + " bên dưới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2028796543 = messageFormatterFn((function(  ) {
  return function(d) { return "Hủy, đóng trang thông tin khách và không lưu thay đổi. Hoặc chỉnh sửa thông tin khách bên dưới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1030278657 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoàn tất"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b126540919 = messageFormatterFn((function(  ) {
  return function(d) { return "Lưu thay đổi và đóng trang thông tin khách."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a160493123 = messageFormatterFn((function(  ) {
  return function(d) { return "Thêm phòng khác"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1946363454 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa phòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a763303238 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa phòng " + d["0"] + " / " + d["1"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a908866844 = messageFormatterFn((function(  ) {
  return function(d) { return "Tuổi của trẻ " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1209387540 = messageFormatterFn((function(  ) {
  return function(d) { return "Phòng " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1144137035 = messageFormatterFn((function(  ) {
  return function(d) { return "Phòng " + d["0"] + "/" + d["1"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1211504173 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã cập nhật trẻ " + d["0"] + ", " + d["1"] + " tuổi."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1810354311 = messageFormatterFn((function(  ) {
  return function(d) { return "Dưới 1"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1569713803 = messageFormatterFn((function(  ) {
  return function(d) { return "Trẻ em"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b718214690 = messageFormatterFn((function(  ) {
  return function(d) { return "(Tuổi 0-17)"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1323727265 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["0"]) + " người lớn";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.a279643685 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["0"]) + " trẻ em";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1803129263 = messageFormatterFn((function(  ) {
  return function(d) { return "Người lớn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1406892557 = messageFormatterFn((function(  ) {
  return function(d) { return "Giảm số trẻ trong phòng " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b270339501 = messageFormatterFn((function(  ) {
  return function(d) { return "Giảm số người lớn trong phòng " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2121857047 = messageFormatterFn((function(  ) {
  return function(d) { return "Tăng số trẻ trong phòng " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1401964335 = messageFormatterFn((function(  ) {
  return function(d) { return "Tăng số người lớn trong phòng " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a379699013 = messageFormatterFn((function(  ) {
  return function(d) { return "Vật nuôi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1623745761 = messageFormatterFn((function(  ) {
  return function(d) { return "Có vật nuôi không?"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a458869013 = messageFormatterFn((function(  ) {
  return function(d) { return "Có"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b653013561 = messageFormatterFn((function(  ) {
  return function(d) { return "Không"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b227839919 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã thêm " + d["0"] + " vào danh sách"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2009075605 = messageFormatterFn((function(  ) {
  return function(d) { return "Mở trong cửa sổ mới"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1795519808 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhận xét của khách"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b514135160 = messageFormatterFn((function(  ) {
  return function(d) { return "Hủy, trở lại trang chi tiết khách sạn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1636251088 = messageFormatterFn((function(  ) {
  return function(d) { return "Kiểm tra phòng trống"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b778214021 = messageFormatterFn((function(  ) {
  return function(d) { return "Tìm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1084914441 = messageFormatterFn((function(  ) {
  return function(d) { return "Thay đổi tìm kiếm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a702156852 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn ngày nhận phòng muộn hơn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1756590224 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn ngày nhận phòng sớm hơn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a747276843 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn ngày trả phòng muộn hơn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1801710215 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn ngày trả phòng sớm hơn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1149509407 = messageFormatterFn((function(  ) {
  return function(d) { return "Giá cũ là " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1898847121 = messageFormatterFn((function(  ) {
  return function(d) { return "Giá: " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a376229140 = messageFormatterFn((function(  ) {
  return function(d) { return "Giá hiện tại là " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a274684258 = messageFormatterFn((function(  ) {
  return function(d) { return "Giá cũ: " + d["0"] + ", giá hiện tại: " + d["1"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1827299141 = messageFormatterFn((function(  ) {
  return function(d) { return "mỗi đêm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1408979189 = messageFormatterFn((function(  ) {
  return function(d) { return "Hủy, trở lại trang chi tiết khách sạn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b195575325 = messageFormatterFn((function(  ) {
  return function(d) { return "Tìm hiểu thêm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2062706195 = messageFormatterFn((function(  ) {
  return function(d) { return "Đóng, trở lại trang chi tiết khách sạn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2011943529 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã có lỗi phát sinh."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a585283921 = messageFormatterFn((function(  ) {
  return function(d) { return "Thử tìm lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1077674713 = messageFormatterFn((function(  ) {
  return function(d) { return "Xem tùy chọn và đặt"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2103905740 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn cũng có thể quan tâm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1540204697 = messageFormatterFn((function(  ) {
  return function(d) { return "Đóng bộ lọc"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1551139217 = messageFormatterFn((function(  ) {
  return function(d) { return "Sắp xếp & Lọc"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1013125681 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoàn tất"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a829585148 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a414213267 = messageFormatterFn((function(  ) {
  return function(d) { return "Bấm áp dụng hoặc di chuyển trở lại để đóng bộ lọc"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b481003243 = messageFormatterFn((function(  ) {
  return function(d) { return "Giá tối thiểu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1360160857 = messageFormatterFn((function(  ) {
  return function(d) { return "Giá tối đa"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a341892852 = messageFormatterFn((function(  ) {
  return function(d) { return "Xếp hạng sao"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b802377213 = messageFormatterFn((function(  ) {
  return function(d) { return "Sắp xếp theo thứ tự"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1174747012 = messageFormatterFn((function(  ) {
  return function(d) { return "Lọc theo"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b80098500 = messageFormatterFn((function(  ) {
  return function(d) { return "Trở lại trang tìm khách sạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a661737970 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang tìm hàng ngàn nơi lưu trú"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1089001395 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang tìm hàng ngàn ưu đãi trọn gói"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a3318817 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Đã áp dụng " + plural(d["0"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["0"]) + " bộ lọc";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1434913695 = messageFormatterFn((function(  ) {
  return function(d) { return "Sắp xếp & lọc"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1351705547 = messageFormatterFn((function(  ) {
  return function(d) { return "Bộ lọc"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b516104574 = messageFormatterFn((function(  ) {
  return function(d) { return "Bản đồ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a162598815 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang tải kết quả"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a377111104 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã cập nhật kết quả"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2093766288 = messageFormatterFn((function(  ) {
  return function(d) { return "Có lỗi khi tải kết quả"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1246770556 = messageFormatterFn((function(  ) {
  return function(d) { return "Kết quả trống"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b517813126 = messageFormatterFn((function(  ) {
  return function(d) { return "Tìm khách sạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1659918377 = messageFormatterFn((function(  ) {
  return function(d) { return "Đóng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a255476140 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy thử những ngày này"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b873494758 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiện nhiều ngày"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b911315874 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiện ít ngày"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b198619407 = messageFormatterFn((function(  ) {
  return function(d) { return "Kết quả tìm kiếm khách sạn tại " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1900472149 = messageFormatterFn((function(  ) {
  return function(d) { return "Kết quả tìm kiếm nhà và căn hộ tại " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1127057860 = messageFormatterFn((function(  ) {
  return function(d) { return "Kết quả tìm kiếm khách sạn không hợp lệ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1555706150 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiển thị thêm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1437074636 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, không tìm được kết quả. Hãy thử thay đổi tìm kiếm."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a79026466 = messageFormatterFn((function(  ) {
  return function(d) { return "Bộ lọc đã chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1868901180 = messageFormatterFn((function(  ) {
  return function(d) { return "Bộ lọc đã chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a93164932 = messageFormatterFn((function(  ) {
  return function(d) { return "Thiếu điểm đến"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1972309168 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b678068944 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa tất cả bộ lọc"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1824882001 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["0"]) + " khách";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b66518585 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, chúng tôi đang gặp trục trặc"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1922239308 = messageFormatterFn((function(  ) {
  return function(d) { return "Thử lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1228163028 = messageFormatterFn((function(  ) {
  return function(d) { return "Lưu " + d["0"] + " vào danh sách"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a343981858 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa " + d["0"] + " khỏi danh sách"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2000343638 = messageFormatterFn((function(  ) {
  return function(d) { return "Chi tiết chỗ lưu trú tiếp theo"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1579656225 = messageFormatterFn((function(  ) {
  return function(d) { return "Tìm trong khu vực này"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1485981199 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, đã có lỗi phát sinh. Vui lòng thử tìm lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b618615606 = messageFormatterFn((function(  ) {
  return function(d) { return "Đóng bản đồ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b420985982 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["vi-VN"], { zero: function() { return number(d["0"]) + " nơi lưu trú";}, one: function() { return number(d["0"]) + " nơi lưu trú";}, two: function() { return number(d["0"]) + " nơi lưu trú";}, few: function() { return number(d["0"]) + " nơi lưu trú";}, many: function() { return number(d["0"]) + " nơi lưu trú";}, other: function() { return number(d["0"]) + " nơi lưu trú";} }) + "\ntừ " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b888563979 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["vi-VN"], { zero: function() { return number(d["0"]) + " nơi lưu trú";}, one: function() { return number(d["0"]) + " nơi lưu trú";}, two: function() { return number(d["0"]) + " nơi lưu trú";}, few: function() { return number(d["0"]) + " nơi lưu trú";}, many: function() { return number(d["0"]) + " nơi lưu trú";}, other: function() { return number(d["0"]) + " nơi lưu trú";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1024095790 = messageFormatterFn((function(  ) {
  return function(d) { return "Xem thêm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1619671589 = messageFormatterFn((function(  ) {
  return function(d) { return "Xem ít hơn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b380289267 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, hệ thống vừa có trục trặc"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1603989593 = messageFormatterFn((function(  ) {
  return function(d) { return "Mục tiếp"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1490481501 = messageFormatterFn((function(  ) {
  return function(d) { return "Mục trước"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1094938368 = messageFormatterFn((function(  ) {
  return function(d) { return "Trả phòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1417654623 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Chuyến đi của bạn (" + plural(d["0"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["0"]) + " phòng";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.a345573910 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Chuyến đi của bạn (" + plural(d["0"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["0"]) + " nơi lưu trú";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b201329434 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn phòng tiếp theo"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b75483709 = messageFormatterFn((function(  ) {
  return function(d) { return "Không còn chỗ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1370959569 = messageFormatterFn((function(  ) {
  return function(d) { return "Có nhiều hơn một nơi lưu trú bạn chọn không còn chỗ. Vẫn đến trang thanh toán?"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1239502568 = messageFormatterFn((function(  ) {
  return function(d) { return "mỗi phòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2079888384 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["0"]) + " khách";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1486636604 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["0"]) + " phòng";} }) + ", " + plural(d["1"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["1"]) + " khách";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b671542639 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/đêm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1043861063 = messageFormatterFn((function(  ) {
  return function(d) { return "Thay đổi phòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1644977613 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã sao chép mã đến clipboard."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1181535974 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, chúng tôi đang gặp trục trặc"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a496917817 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng thử tìm lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2084061091 = messageFormatterFn((function(  ) {
  return function(d) { return "Thử lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1943961776 = messageFormatterFn((function(  ) {
  return function(d) { return "Nơi nhận và trả xe thuê"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a830816903 = messageFormatterFn((function(  ) {
  return function(d) { return "Giờ nhận xe"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b500864059 = messageFormatterFn((function(  ) {
  return function(d) { return "Thời gian trả xe"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a210293220 = messageFormatterFn((function(  ) {
  return function(d) { return "Xe thuê"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1129938991 = messageFormatterFn((function(  ) {
  return function(d) { return "Giờ trả xe phải sau giờ nhận xe tối thiểu 2 tiếng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1757209853 = messageFormatterFn((function(  ) {
  return function(d) { return "00:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1757299226 = messageFormatterFn((function(  ) {
  return function(d) { return "00:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1758133374 = messageFormatterFn((function(  ) {
  return function(d) { return "01:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1758222747 = messageFormatterFn((function(  ) {
  return function(d) { return "01:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1759056895 = messageFormatterFn((function(  ) {
  return function(d) { return "02:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1759146268 = messageFormatterFn((function(  ) {
  return function(d) { return "02:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1759980416 = messageFormatterFn((function(  ) {
  return function(d) { return "03:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1760069789 = messageFormatterFn((function(  ) {
  return function(d) { return "03:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1760903937 = messageFormatterFn((function(  ) {
  return function(d) { return "04:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1760993310 = messageFormatterFn((function(  ) {
  return function(d) { return "04:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1761827458 = messageFormatterFn((function(  ) {
  return function(d) { return "05:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1761916831 = messageFormatterFn((function(  ) {
  return function(d) { return "05:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1762750979 = messageFormatterFn((function(  ) {
  return function(d) { return "06:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1762840352 = messageFormatterFn((function(  ) {
  return function(d) { return "06:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1763674500 = messageFormatterFn((function(  ) {
  return function(d) { return "07:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1763763873 = messageFormatterFn((function(  ) {
  return function(d) { return "07:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1764598021 = messageFormatterFn((function(  ) {
  return function(d) { return "08:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1764687394 = messageFormatterFn((function(  ) {
  return function(d) { return "08:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1765521542 = messageFormatterFn((function(  ) {
  return function(d) { return "09:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1765610915 = messageFormatterFn((function(  ) {
  return function(d) { return "09:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1785839004 = messageFormatterFn((function(  ) {
  return function(d) { return "10:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1785928377 = messageFormatterFn((function(  ) {
  return function(d) { return "10:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1786762525 = messageFormatterFn((function(  ) {
  return function(d) { return "11:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1786851898 = messageFormatterFn((function(  ) {
  return function(d) { return "11:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1787686046 = messageFormatterFn((function(  ) {
  return function(d) { return "12:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1787775419 = messageFormatterFn((function(  ) {
  return function(d) { return "12:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1788609567 = messageFormatterFn((function(  ) {
  return function(d) { return "13:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1788698940 = messageFormatterFn((function(  ) {
  return function(d) { return "13:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1789533088 = messageFormatterFn((function(  ) {
  return function(d) { return "14:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1789622461 = messageFormatterFn((function(  ) {
  return function(d) { return "14:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1790456609 = messageFormatterFn((function(  ) {
  return function(d) { return "15:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1790545982 = messageFormatterFn((function(  ) {
  return function(d) { return "15:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1791380130 = messageFormatterFn((function(  ) {
  return function(d) { return "16:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1791469503 = messageFormatterFn((function(  ) {
  return function(d) { return "16:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1792303651 = messageFormatterFn((function(  ) {
  return function(d) { return "17:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1792393024 = messageFormatterFn((function(  ) {
  return function(d) { return "17:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1793227172 = messageFormatterFn((function(  ) {
  return function(d) { return "18:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1793316545 = messageFormatterFn((function(  ) {
  return function(d) { return "18:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1794150693 = messageFormatterFn((function(  ) {
  return function(d) { return "19:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1794240066 = messageFormatterFn((function(  ) {
  return function(d) { return "19:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1814468155 = messageFormatterFn((function(  ) {
  return function(d) { return "20:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1814557528 = messageFormatterFn((function(  ) {
  return function(d) { return "20:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1815391676 = messageFormatterFn((function(  ) {
  return function(d) { return "21:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1815481049 = messageFormatterFn((function(  ) {
  return function(d) { return "21:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1816315197 = messageFormatterFn((function(  ) {
  return function(d) { return "22:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1816404570 = messageFormatterFn((function(  ) {
  return function(d) { return "22:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1817238718 = messageFormatterFn((function(  ) {
  return function(d) { return "23:00"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1817328091 = messageFormatterFn((function(  ) {
  return function(d) { return "23:30"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b477701762 = messageFormatterFn((function(  ) {
  return function(d) { return "Chỉ chuyến bay thẳng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1787543857 = messageFormatterFn((function(  ) {
  return function(d) { return "Hạng chỗ ngồi ưu tiên chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1778738617 = messageFormatterFn((function(  ) {
  return function(d) { return "Phổ thông"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1135256786 = messageFormatterFn((function(  ) {
  return function(d) { return "Hạng Phổ thông Đặc biệt"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a195276423 = messageFormatterFn((function(  ) {
  return function(d) { return "Thương gia"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b903175697 = messageFormatterFn((function(  ) {
  return function(d) { return "Hạng Nhất"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1152410426 = messageFormatterFn((function(  ) {
  return function(d) { return "Khách"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1779142140 = messageFormatterFn((function(  ) {
  return function(d) { return "Phải có ít nhất 1 khách từ 6 tuổi trở lên đi cùng 1 trẻ sơ sinh ngồi trong lòng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1409590217 = messageFormatterFn((function(  ) {
  return function(d) { return "Trẻ sơ sinh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b657482688 = messageFormatterFn((function(  ) {
  return function(d) { return "(Tuổi 2-17)"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1665102670 = messageFormatterFn((function(  ) {
  return function(d) { return "Dưới 2 tuổi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a549522848 = messageFormatterFn((function(  ) {
  return function(d) { return "Tuổi của trẻ sơ sinh " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1697790276 = messageFormatterFn((function(  ) {
  return function(d) { return "Giảm số trẻ sơ sinh trong phòng " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a473950616 = messageFormatterFn((function(  ) {
  return function(d) { return "Tăng số trẻ sơ sinh trong phòng " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1455084886 = messageFormatterFn((function(  ) {
  return function(d) { return "Trẻ dưới 2 tuổi phải ngồi ghế riêng hoặc trong lòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1419670226 = messageFormatterFn((function(  ) {
  return function(d) { return "Trong lòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a511795344 = messageFormatterFn((function(  ) {
  return function(d) { return "Chỗ riêng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1463851057 = messageFormatterFn((function(  ) {
  return function(d) { return "Quy tắc tuổi của hãng hàng không"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2147066299 = messageFormatterFn((function(  ) {
  return function(d) { return "Đi từ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b562173107 = messageFormatterFn((function(  ) {
  return function(d) { return "Khởi hành"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b523270775 = messageFormatterFn((function(  ) {
  return function(d) { return "Trở về"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1681612569 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng chọn điểm khởi hành"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1376076321 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi chỉ cần nơi lưu trú cho một phần của chuyến đi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1510425054 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, đã có lỗi phát sinh. Vui lòng thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a543112822 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn thêm ít nhất 1 nơi lưu trú để so sánh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1662022861 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Đã chọn " + d["0"] + "/" + plural(d["1"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["1"]) + " nơi lưu trú";}, one: function() { return number(d["1"]) + " nơi lưu trú";}, two: function() { return number(d["1"]) + " nơi lưu trú";}, few: function() { return number(d["1"]) + " nơi lưu trú";}, many: function() { return number(d["1"]) + " nơi lưu trú";}, other: function() { return number(d["1"]) + " nơi lưu trú";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b615367313 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Đã chọn " + d["0"] + "/" + plural(d["1"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["1"]) + " nơi lưu trú";}, one: function() { return number(d["1"]) + " nơi lưu trú";}, two: function() { return number(d["1"]) + " nơi lưu trú";}, few: function() { return number(d["1"]) + " nơi lưu trú";}, many: function() { return number(d["1"]) + " nơi lưu trú";}, other: function() { return number(d["1"]) + " nơi lưu trú";} }) + " để so sánh"; }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b733800451 = messageFormatterFn((function(  ) {
  return function(d) { return "So sánh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b784984001 = messageFormatterFn((function(  ) {
  return function(d) { return "So sánh nơi lưu trú đã chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1999008409 = messageFormatterFn((function(  ) {
  return function(d) { return "So sánh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a579796771 = messageFormatterFn((function(  ) {
  return function(d) { return "So sánh nơi lưu trú đã chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1579847211 = messageFormatterFn((function(  ) {
  return function(d) { return "Xem"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b20306585 = messageFormatterFn((function(  ) {
  return function(d) { return "Bấm để xem nơi lưu trú"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a478087860 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1561837592 = messageFormatterFn((function(  ) {
  return function(d) { return "Bấm để xóa nơi lưu trú khỏi bảng so sánh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1464897118 = messageFormatterFn((function(  ) {
  return function(d) { return "Đóng phần so sánh nơi lưu trú"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1936816456 = messageFormatterFn((function(  ) {
  return function(d) { return "So sánh nơi lưu trú"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a199344033 = messageFormatterFn((function(  ) {
  return function(d) { return "So sánh tới 5 nơi lưu trú cùng lúc để giúp bạn quyết định dễ dàng hơn. Chọn “So sánh” để bắt đầu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1884523011 = messageFormatterFn((function(  ) {
  return function(d) { return "So sánh tới 5 nơi lưu trú cùng lúc để giúp bạn quyết định dễ dàng hơn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a686554373 = messageFormatterFn((function(  ) {
  return function(d) { return "Thử ngay"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b191825633 = messageFormatterFn((function(  ) {
  return function(d) { return "Bắt đầu so sánh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a72818253 = messageFormatterFn((function(  ) {
  return function(d) { return "Tắt tính năng “So sánh”"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2037776169 = messageFormatterFn((function(  ) {
  return function(d) { return "Để sau"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1536598444 = messageFormatterFn((function(  ) {
  return function(d) { return "So sánh nơi lưu trú"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b224775417 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn “So sánh” trong kết quả tìm kiếm để bắt đầu."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1621721949 = messageFormatterFn((function(  ) {
  return function(d) { return "Xem cùng lúc đến 5 nơi lưu trú được hiển thị cạnh nhau."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a737835398 = messageFormatterFn((function(  ) {
  return function(d) { return "Không còn phòng vào ngày " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b354822941 = messageFormatterFn((function(  ) {
  return function(d) { return "Không thể trả phòng vào " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1361378158 = messageFormatterFn((function(  ) {
  return function(d) { return "Không thể nhận phòng vào " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1724196420 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b351041967 = messageFormatterFn((function(  ) {
  return function(d) { return "Tùy chỉnh kỳ lưu trú"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1822743025 = messageFormatterFn((function(  ) {
  return function(d) { return "Đóng phần tùy chỉnh kỳ lưu trú"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1401018659 = messageFormatterFn((function(  ) {
  return function(d) { return "Đóng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1697847477 = messageFormatterFn((function(  ) {
  return function(d) { return "Hủy"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1410716561 = messageFormatterFn((function(  ) {
  return function(d) { return "Bỏ qua"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1371633619 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoàn tất"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2087495979 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1208535468 = messageFormatterFn((function(  ) {
  return function(d) { return "đã chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b171542879 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang tải"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1410777614 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b580111692 = messageFormatterFn((function(  ) {
  return function(d) { return "Mở trong cửa sổ mới"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a48567878 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiển thị thêm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1522980243 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiển thị ít hơn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a540801841 = messageFormatterFn((function(  ) {
  return function(d) { return "Xem thêm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2113416126 = messageFormatterFn((function(  ) {
  return function(d) { return "Xem ít hơn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a542960493 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã chọn " + d["0"] + ". Tiếp tục chọn ngày trả phòng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b769835452 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã chọn " + d["0"] + ". Giờ hãy chọn hoàn tất để lưu những ngày vừa chọn và đóng lịch."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b56878488 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", ngày nhận phòng hiện tại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1021206727 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", ngày trả phòng hiện tại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b407201649 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", đã tắt ngày"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1007084212 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " tháng này"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1651871975 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang hiển thị " + d["0"] + " " + d["1"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1323935331 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã mở lịch. Hãy chọn ngày từ bảng bên dưới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1820238737 = messageFormatterFn((function(  ) {
  return function(d) { return "Hủy, đóng lịch và không lưu thay đổi. Hoặc chọn ngày từ bảng bên dưới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b100810785 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa ngày đã chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1722970380 = messageFormatterFn((function(  ) {
  return function(d) { return "Lưu thay đổi và đóng lịch."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b59521115 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["0"]) + " đêm";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.a912145461 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhận phòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a322052230 = messageFormatterFn((function(  ) {
  return function(d) { return "Trả phòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1159092359 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa ngày"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1584943782 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoàn tất"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1092726732 = messageFormatterFn((function(  ) {
  return function(d) { return "Tìm kiếm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b91823102 = messageFormatterFn((function(  ) {
  return function(d) { return "Chỉnh sửa ngày nhận phòng trong bảng bên dưới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1596848557 = messageFormatterFn((function(  ) {
  return function(d) { return "Chỉnh sửa ngày trả phòng trong bảng bên dưới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1626965438 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã chọn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1627163985 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã chọn " + d["0"] + ". Đóng lịch hoặc tiếp tục thay đổi ngày đã chọn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b48690953 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã chọn từ " + d["0"] + " đến " + d["1"] + ". Đóng lịch hoặc tiếp tục thay đổi ngày đã chọn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1395096189 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã chọn " + d["0"] + ". " + d["1"] + ". Đóng lịch hoặc tiếp tục thay đổi ngày đã chọn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a945444165 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã chọn từ " + d["0"] + " đến " + d["1"] + ". " + d["2"] + ". Đóng lịch hoặc tiếp tục thay đổi ngày đã chọn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1900493826 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn ngày nhận phòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1620356933 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn ngày trả phòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a759172458 = messageFormatterFn((function(  ) {
  return function(d) { return "bỏ trống"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a26714440 = messageFormatterFn((function(  ) {
  return function(d) { return "Tháng trước"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1527209044 = messageFormatterFn((function(  ) {
  return function(d) { return "Tháng sau"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1443384349 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhảy đến nút " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b879016453 = messageFormatterFn((function(  ) {
  return function(d) { return "Từ " + d["0"] + " đến " + d["1"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b680654174 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã xóa ngày"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2092511605 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["vi-VN"], { 0: function() { return "Không có kết quả nào";}, other: function() { return "Có " + number(d["0"]) + " kết quả";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b862150708 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "“" + d["0"] + "” " + plural(d["1"], 0, pluralFuncs["vi-VN"], { zero: function() { return "có " + number(d["1"]) + " kết quả";}, one: function() { return "có " + number(d["1"]) + " kết quả";}, two: function() { return "có " + number(d["1"]) + " kết quả";}, few: function() { return "có " + number(d["1"]) + " kết quả";}, many: function() { return "có " + number(d["1"]) + " kết quả";}, other: function() { return "có " + number(d["1"]) + " kết quả";} }) + " kết quả. Hãy sử dụng phím mũi tên hoặc trượt để di chuyển đến danh sách."; }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1476342520 = messageFormatterFn((function(  ) {
  return function(d) { return "Mở tìm kiếm " + d["0"] + ", nhập từ cần tìm."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b53624985 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn đã chọn " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1556962436 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã đóng menu."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1827118902 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Mở tìm kiếm " + d["0"] + ", đang hiển thị " + plural(d["1"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["1"]) + " gợi ý";} }) + " cho " + d["2"] + ". Di chuyển đến danh sách bên dưới."; }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1517185837 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Mở tìm kiếm " + d["0"] + ", đang hiển thị " + plural(d["1"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["1"]) + " gợi ý";} }) + ". Nhập từ cần tìm hoặc di chuyển đến danh sách bên dưới."; }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1207614775 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Mở tìm kiếm " + d["0"] + ", đang chọn " + d["1"] + ". Đang hiển thị " + plural(d["2"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["2"]) + " gợi ý";} }) + " cho " + d["3"] + ". Di chuyển đến danh sách bên dưới."; }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1485080015 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoàn tất"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b457096294 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa tất cả"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1351069593 = messageFormatterFn((function(  ) {
  return function(d) { return "Những mục đã chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1338410522 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã xóa " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a372212851 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã xóa tất cả lựa chọn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1362063586 = messageFormatterFn((function(  ) {
  return function(d) { return "Quý vị đã nhập thông tin. Vui lòng tìm hoặc chọn từ những hạng mục bên dưới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b34457985 = messageFormatterFn((function(  ) {
  return function(d) { return "Tìm “" + d["0"] + "”"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a480840574 = messageFormatterFn((function(  ) {
  return function(d) { return "Không tìm được kết quả cho “" + d["0"] + "”"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1899541676 = messageFormatterFn((function(  ) {
  return function(d) { return "Sân bay"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1307773571 = messageFormatterFn((function(  ) {
  return function(d) { return "Khách sạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1683368941 = messageFormatterFn((function(  ) {
  return function(d) { return "Danh thắng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b319373020 = messageFormatterFn((function(  ) {
  return function(d) { return "Lân cận"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b559205895 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy thử \"" + d["0"] + "\""; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a977790732 = messageFormatterFn((function(  ) {
  return function(d) { return "Thành phố/Khu vực"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1745383200 = messageFormatterFn((function(  ) {
  return function(d) { return "Sân bay"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1167595912 = messageFormatterFn((function(  ) {
  return function(d) { return "Danh thắng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a560541193 = messageFormatterFn((function(  ) {
  return function(d) { return "Khách sạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1361598007 = messageFormatterFn((function(  ) {
  return function(d) { return "Địa chỉ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b590007955 = messageFormatterFn((function(  ) {
  return function(d) { return "Ga tàu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1436572028 = messageFormatterFn((function(  ) {
  return function(d) { return "Ga metro"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1246568864 = messageFormatterFn((function(  ) {
  return function(d) { return "Địa điểm lân cận"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b510637463 = messageFormatterFn((function(  ) {
  return function(d) { return "Tìm gần đây"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1643637169 = messageFormatterFn((function(  ) {
  return function(d) { return "Khách khác cũng đã tìm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b78366394 = messageFormatterFn((function(  ) {
  return function(d) { return "Khám phá điểm đến hot"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1439357806 = messageFormatterFn((function(  ) {
  return function(d) { return "Điểm đến nổi tiếng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a465581262 = messageFormatterFn((function(  ) {
  return function(d) { return "Điểm đến nổi bật"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b450443568 = messageFormatterFn((function(  ) {
  return function(d) { return "Địa điểm của bạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b507781747 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang tắt tính năng chia sẻ địa điểm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a307059619 = messageFormatterFn((function(  ) {
  return function(d) { return "Không xác định được địa điểm hiện tại của bạn. Vui lòng bật tính năng địa điểm trên thiết bị để giúp chúng tôi xác định vị trí hoặc nhập điểm đến mong muốn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1877996063 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["0"]) + " phòng";} }) + ", " + plural(d["1"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["1"]) + " khách";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1366192171 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["vi-VN"], { other: function() { return number(d["0"]) + " khách";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1249189393 = messageFormatterFn((function(  ) {
  return function(d) { return "Giá trị của trường " + d["0"] + " nay là " + d["1"] + ". Giá trị của trường " + d["2"] + " nay là " + d["3"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a349496094 = messageFormatterFn((function(  ) {
  return function(d) { return "Đổi vị trí của trường " + d["0"] + " và " + d["1"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a117228373 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiển thị mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b197113766 = messageFormatterFn((function(  ) {
  return function(d) { return "Ẩn mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1303650835 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang hiển thị " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1116729762 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/" + d["1"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1245267796 = messageFormatterFn((function(  ) {
  return function(d) { return "Ảnh " + d["0"] + " / " + d["1"] + " " + d["2"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a973886673 = messageFormatterFn((function(  ) {
  return function(d) { return "Tải ảnh tiếp theo"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a925700429 = messageFormatterFn((function(  ) {
  return function(d) { return "Tải ảnh trước đó"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1480442963 = messageFormatterFn((function(  ) {
  return function(d) { return "Tải tất cả " + d["0"] + " ảnh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1448781720 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Hiển thị " + plural(d["0"], 0, pluralFuncs["vi-VN"], { zero: function() { return number(d["0"]) + " hình ảnh";}, one: function() { return number(d["0"]) + " hình ảnh";}, two: function() { return number(d["0"]) + " hình ảnh";}, few: function() { return "tất cả " + number(d["0"]) + " hình ảnh";}, many: function() { return "tất cả " + number(d["0"]) + " hình ảnh";}, other: function() { return "tất cả " + number(d["0"]) + " hình ảnh";} }) + " cho " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.b322697435 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã hoàn tất:"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a455734931 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiện tại:"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b727284607 = messageFormatterFn((function(  ) {
  return function(d) { return "Bước " + d["0"] + "/" + d["1"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1017782725 = messageFormatterFn((function(  ) {
  return function(d) { return "Bước " + d["0"] + "/" + d["1"] + ":"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1528516356 = messageFormatterFn((function(  ) {
  return function(d) { return "Ảnh " + d["0"] + " trên " + d["1"] + ". " + d["2"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a5638265 = messageFormatterFn((function(  ) {
  return function(d) { return "Ảnh tiếp theo"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1801146123 = messageFormatterFn((function(  ) {
  return function(d) { return "Ảnh trước"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1511430247 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", mở rộng toàn màn hình"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1123161253 = messageFormatterFn((function(  ) {
  return function(d) { return "Mục " + d["0"] + ", mở rộng toàn màn hình"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1180312943 = messageFormatterFn((function(  ) {
  return function(d) { return "Trang hiện tại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b925565919 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiển thị thêm đường dẫn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b963387035 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiển thị ít đường dẫn hơn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1921974792 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang tải, " + d["0"] + " phần trăm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2072146045 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang tải"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1674303053 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b115721692 = messageFormatterFn((function(  ) {
  return function(d) { return "Có lỗi phát sinh."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1259879928 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy thử xem video này trực tiếp tại www.youtube.com hoặc bật Javascript trên trình duyệt (nếu đã tắt trước đây)."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1894309072 = messageFormatterFn((function(  ) {
  return function(d) { return "Phát video"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a655176000 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạm dừng video"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a424600472 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang tải video"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1432330802 = messageFormatterFn((function(  ) {
  return function(d) { return "Ảnh 360 độ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1644253208 = messageFormatterFn((function(  ) {
  return function(d) { return "Đây là ảnh 360 độ. Sử dụng phím Ctrl và phím mũi tên hoặc phím Command và phím mũi tên để di chuyển xung quanh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a214669019 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiện đang hiển thị: " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1630936326 = messageFormatterFn((function(  ) {
  return function(d) { return "Di chuyển qua bên trái. Vị trí: " + d["0"] + " độ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2125795935 = messageFormatterFn((function(  ) {
  return function(d) { return "Di chuyển qua bên phải. Vị trí: " + d["0"] + " độ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1080142478 = messageFormatterFn((function(  ) {
  return function(d) { return "Di chuyển lên trên"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1850233643 = messageFormatterFn((function(  ) {
  return function(d) { return "Di chuyển xuống dưới"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1029915270 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn đã chạm đến đỉnh của tấm ảnh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b74373444 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn đã chạm đến đáy của tấm ảnh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a787339920 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn tất cả các hàng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1664531759 = messageFormatterFn((function(  ) {
  return function(d) { return "Bỏ chọn tất cả các hàng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1214806207 = messageFormatterFn((function(  ) {
  return function(d) { return "Sắp xếp cột theo thứ tự giảm dần"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b159929209 = messageFormatterFn((function(  ) {
  return function(d) { return "Sắp xếp cột theo thứ tự tăng dần"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1793131881 = messageFormatterFn((function(  ) {
  return function(d) { return "Cột đang được sắp xếp theo thứ tự giảm dần"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1875269937 = messageFormatterFn((function(  ) {
  return function(d) { return "Cột đang được sắp xếp theo thứ tự tăng dần"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b817625865 = messageFormatterFn((function(  ) {
  return function(d) { return "Mở rộng hàng " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1980165610 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Hiển thị " + d["0"] + "/" + plural(d["1"], 0, pluralFuncs["vi-VN"], { zero: function() { return number(d["1"]) + " mục";}, other: function() { return number(d["1"]) + " mục";} }); }
})(messageFormat.number, messageFormat.plural, {"vi-VN": Globalize("vi-VN").pluralGenerator()}), Globalize("vi-VN").pluralGenerator({}));
Globalize.a594860602 = messageFormatterFn((function(  ) {
  return function(d) { return "bạn đang xem tháng " + d["0"] + " năm " + d["1"] + " và " + d["2"] + " năm " + d["3"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1371722862 = messageFormatterFn((function(  ) {
  return function(d) { return "bạn đang xem tháng " + d["0"] + " năm " + d["1"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1742977027 = messageFormatterFn((function(  ) {
  return function(d) { return "bạn đang xem các tháng từ tháng " + d["0"] + " năm " + d["1"] + " đến tháng " + d["2"] + " năm " + d["3"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1770198114 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã xóa ngày nhận phòng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1366652491 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã xóa ngày trả phòng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1759638134 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã xóa ngày."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1917616987 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa ngày"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1329165947 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a550159784 = messageFormatterFn((function(  ) {
  return function(d) { return "Tiếp theo"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1005358312 = messageFormatterFn((function(  ) {
  return function(d) { return "Trước"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b428637682 = messageFormatterFn((function(  ) {
  return function(d) { return "Chuyển đến nút Gửi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1673829183 = messageFormatterFn((function(  ) {
  return function(d) { return "Chuyển đến nút " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1160960626 = messageFormatterFn((function(  ) {
  return function(d) { return "Tháng sau"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1843783246 = messageFormatterFn((function(  ) {
  return function(d) { return "Tháng trước"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a450387223 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn chọn ngày nhận phòng là " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1992266276 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn chọn ngày trả phòng là " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1369479117 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " không phải là ngày nhận phòng hợp lệ."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a916818034 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " không phải là ngày trả phòng hợp lệ."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1495315071 = messageFormatterFn((function(  ) {
  return function(d) { return "Không còn phòng vào ngày " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1371450480 = messageFormatterFn((function(  ) {
  return function(d) { return "Hôm nay"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1538507890 = messageFormatterFn((function(  ) {
  return function(d) { return "Ngày nhận phòng đã chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b889581589 = messageFormatterFn((function(  ) {
  return function(d) { return "Ngày trả phòng đã chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a501141290 = messageFormatterFn((function(  ) {
  return function(d) { return "Ngày đã chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1057042938 = messageFormatterFn((function(  ) {
  return function(d) { return "Ngày bắt đầu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b332941761 = messageFormatterFn((function(  ) {
  return function(d) { return "Ngày kết thúc"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a388128352 = messageFormatterFn((function(  ) {
  return function(d) { return "Hủy, đóng lịch và không lưu thay đổi. Hoặc chọn ngày từ bảng bên dưới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1304191313 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " trên " + d["1"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1520492570 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhấn nút esc để đóng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1353870513 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhấn nút esc để thu gọn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b110727394 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập số nhỏ hơn " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1979641827 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập số lớn hơn " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1606137584 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập số trong khoảng từ " + d["0"] + " đến " + d["1"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1554052255 = messageFormatterFn((function(  ) {
  return function(d) { return "Bắt buộc"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b860399291 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập vào " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a691832702 = messageFormatterFn((function(  ) {
  return function(d) { return "Xin chào! Đăng nhập bằng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1388403356 = messageFormatterFn((function(  ) {
  return function(d) { return "Xin chào! Đăng nhập và tiết kiệm thêm 10% trở lên tại hàng ngàn nơi lưu trú với giá thành viên."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1608578786 = messageFormatterFn((function(  ) {
  return function(d) { return "Địa chỉ email"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2105115375 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a159986732 = messageFormatterFn((function(  ) {
  return function(d) { return "Cần tài khoản?"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1040762054 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang đăng nhập"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b467631261 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập bằng Facebook"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1503016598 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập bằng Google"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1382055654 = messageFormatterFn((function(  ) {
  return function(d) { return "Giữ tôi luôn đăng nhập"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b589814583 = messageFormatterFn((function(  ) {
  return function(d) { return "Giữ tôi luôn đăng nhập (sử dụng cookie)"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a791747135 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a792106549 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng ký"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1091833199 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoặc, <a href=\"" + d["0"] + "\">đăng nhập bằng Facebook</a>"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b890117029 = messageFormatterFn((function(  ) {
  return function(d) { return "Quên mật khẩu?"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1121352942 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhập địa chỉ email"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2038795260 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập địa chỉ email hợp lệ."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a507167 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhập mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a859046629 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng thử lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1256688407 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã xảy ra lỗi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1899361095 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng sửa lỗi bên dưới để tiếp tục"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b226222178 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng sửa 2 lỗi bên dưới để tiếp tục"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b614568212 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập bằng email"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a832070119 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoặc đăng nhập bằng email"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1095690334 = messageFormatterFn((function(  ) {
  return function(d) { return "Email"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1898898273 = messageFormatterFn((function(  ) {
  return function(d) { return "hoặc"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1076628877 = messageFormatterFn((function(  ) {
  return function(d) { return "Quên mật khẩu?"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a118102480 = messageFormatterFn((function(  ) {
  return function(d) { return "Chưa là thành viên?"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a453864346 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a562757109 = messageFormatterFn((function(  ) {
  return function(d) { return "Bằng việc đăng nhập, tôi đồng ý với <a href=\"" + d["0"] + "\" target=\"_blank\">Điều khoản & Điều kiện" + d["1"] + ". <span class=\"is-visually-hidden\">mở trong cửa sổ mới</span></a>"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1321079487 = messageFormatterFn((function(  ) {
  return function(d) { return "Bằng việc đăng nhập tài khoản " + d["0"] + ", tôi đồng ý với <a href=\"" + d["1"] + "\" target=\"_blank\">Điều khoản sử dụng " + d["2"] + "<span class=\"is-visually-hidden\">mở trong cửa sổ mới</span></a>, <a href=\"" + d["3"] + "\" target=\"_blank\">Chính sách Bảo mật<span class=\"is-visually-hidden\">mở trong cửa sổ mới</span></a> và <a href=\"" + d["4"] + "\" target=\"_blank\">Điều khoản & Điều kiện " + d["5"] + "<span class=\"is-visually-hidden\">mở trong cửa sổ mới</span></a>. "; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1874642747 = messageFormatterFn((function(  ) {
  return function(d) { return "Tham gia <a href=\"" + d["0"] + "\" target=\"_blank\">" + d["1"] + ". <span class=\"is-visually-hidden\">mở trong cửa sổ mới</span></a> Bằng việc tham gia, tôi đồng ý tất cả <a href=\"" + d["3"] + "\" target=\"_blank\">Điều khoản & Điều kiện. <span class=\"is-visually-hidden\">mở trong cửa sổ mới</span></a>"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1945077643 = messageFormatterFn((function(  ) {
  return function(d) { return "Có điều khoản áp dụng, link ở cuối trang"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1268534631 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy kiểm tra hộp thư của bạn!"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b633325762 = messageFormatterFn((function(  ) {
  return function(d) { return "Thiết lập lại mật khẩu bằng đường link chúng tôi gửi đến " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b858971445 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi lại link"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1221537407 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, đã có lỗi phát sinh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2041952612 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1336052481 = messageFormatterFn((function(  ) {
  return function(d) { return "Quay lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1173673441 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã gửi đường link mới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a323261499 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo tài khoản trên " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1353077388 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo tài khoản bằng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1282882462 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo tài khoản bằng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a49882801 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoặc tạo tài khoản bằng địa chỉ email của bạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a371771817 = messageFormatterFn((function(  ) {
  return function(d) { return "Họ và tên"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1248359037 = messageFormatterFn((function(  ) {
  return function(d) { return "Tên và họ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1045690718 = messageFormatterFn((function(  ) {
  return function(d) { return "Phải gồm 8 đến 30 ký tự và không có khoảng trống"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a805646396 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1034347211 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã có tài khoản?"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b720736961 = messageFormatterFn((function(  ) {
  return function(d) { return "Bằng việc tạo tài khoản, tôi đồng ý với <a href=\"" + d["1"] + "\" target=\"_blank\">Điều khoản sử dụng " + d["0"] + ", <span class=\"is-visually-hidden\">mở trong cửa sổ mới</span></a> <a href=\"" + d["2"] + "\" target=\"_blank\">Chính sách Bảo mật, <span class=\"is-visually-hidden\">mở trong cửa sổ mới</span></a> và <a href=\"" + d["3"] + "\" target=\"_blank\">Điều khoản & điều kiện " + d["4"] + ". <span class=\"is-visually-hidden\">mở trong cửa sổ mới</span></a>"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1009474714 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy gửi thông tin ưu đãi du lịch, khuyến mãi đặc biệt và các thông tin khác qua email cho tôi."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b297222224 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi đã gửi đường link để bạn hoàn tất tạo tài khoản. "; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1480986469 = messageFormatterFn((function(  ) {
  return function(d) { return "Để hoàn tất tạo tài khoản, vui lòng bấm đường link trong email được gửi đến " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1527375206 = messageFormatterFn((function(  ) {
  return function(d) { return "Thiết lập lại mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b893795872 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhập địa chỉ email của bạn và chúng tôi sẽ gửi link để bạn thiết lập lại mật khẩu."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1077118550 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a83419558 = messageFormatterFn((function(  ) {
  return function(d) { return "hoặc thanh toán như người dùng khách"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1764237108 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn mật khẩu mới"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b397183949 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo mật khẩu mới"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b615451026 = messageFormatterFn((function(  ) {
  return function(d) { return "Email: " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1623667172 = messageFormatterFn((function(  ) {
  return function(d) { return "Lưu mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1575707562 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, đường link này đã hết hạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1628414251 = messageFormatterFn((function(  ) {
  return function(d) { return "Để thiết lập lại mật khẩu, vui lòng yêu cầu đường link mới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2072317803 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi lại đường link mới"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b336027284 = messageFormatterFn((function(  ) {
  return function(d) { return "Quay lại đăng nhập"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b452451563 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi đã gửi đường link mới thiết lập lại mật khẩu đến email của bạn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1704774762 = messageFormatterFn((function(  ) {
  return function(d) { return "Địa chỉ email của bạn?"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1086620975 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập địa chỉ email để nhà cung cấp dịch vụ du lịch hoặc " + d["0"] + " có thể liên hệ bạn. Chúng tôi sẽ gửi mã bảo mật để xác thực danh tính của bạn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a994748418 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn tạo tài khoản " + d["0"] + " bằng số điện thoại. Vui lòng cung cấp địa chỉ email để chúng tôi có thể hoàn tất đăng nhập cho bạn. Chúng tôi sẽ gửi mã bảo mật để xác thực danh tính của bạn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a753070901 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi mã bảo mật"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a539539129 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhập mã bảo mật"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1724603153 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập mã bảo mật chúng tôi gửi đến " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1949485730 = messageFormatterFn((function(  ) {
  return function(d) { return "Mã bảo mật"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b412164732 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a273710330 = messageFormatterFn((function(  ) {
  return function(d) { return "Không nhận được email?"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a570767882 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi mã mới"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a189876497 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi đã gửi bạn mã bảo mật mới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a792578220 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhập mã bảo mật hợp lệ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1920997307 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã vượt quá số lần giới hạn gửi lại mã bảo mật. Vui lòng thử lại sau 24 giờ."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1336950663 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã vượt quá số lần giới hạn nhập mã bảo mật. Vui lòng thử lại sau 24 giờ."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b213246856 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập mã bảo mật đúng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a125800804 = messageFormatterFn((function(  ) {
  return function(d) { return "Địa chỉ email bạn nhập đã được sử dụng để tạo tài khoản trên " + d["0"] + " bằng " + d["1"] + ". Thử đăng nhập bằng tài khoản " + d["1"] + " liên kết với địa chỉ email đó."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1374695485 = messageFormatterFn((function(  ) {
  return function(d) { return "Vì lý do an toàn, vui lòng thiết lập lại mật khẩu để tiếp tục đăng nhập."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1665564633 = messageFormatterFn((function(  ) {
  return function(d) { return "Nếu bạn có tài khoản " + d["0"] + ", chúng tôi sẽ gửi email có đường link để bạn thiết lập lại mật khẩu."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2138393756 = messageFormatterFn((function(  ) {
  return function(d) { return "Chào mừng bạn đã trở lại, " + d["0"] + "!"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1676018474 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã lưu mật khẩu của bạn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1297896372 = messageFormatterFn((function(  ) {
  return function(d) { return "Tiếp tục"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1372133466 = messageFormatterFn((function(  ) {
  return function(d) { return "Xin chào " + d["0"] + "!"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b344330328 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, đã có lỗi phát sinh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a880159559 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng sửa " + d["0"] + " lỗi bên dưới để tiếp tục"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b65816898 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn đã nhập địa chỉ email hoặc mật khẩu không chính xác"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a526511798 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, chúng tôi không thể kết nối đến" + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1298308181 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, đường link đã hết hạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1618067611 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng yêu cầu đường link mới"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a711143457 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, phiên truy cập đã hết hạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b923699241 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhập họ và tên"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a754331295 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhập tên và họ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b422524499 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhập tên chỉ gồm chữ cái"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2017875165 = messageFormatterFn((function(  ) {
  return function(d) { return "Địa chỉ email này đã được liên kết với một tài khoản trên " + d["0"] + "  "; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1966408023 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu không thể chứa khoảng cách."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a90027320 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu phải khác địa chỉ email."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1637796300 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu này dễ đoán được."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1892463219 = messageFormatterFn((function(  ) {
  return function(d) { return "Địa chỉ email này đã được sử dụng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b694366534 = messageFormatterFn((function(  ) {
  return function(d) { return "Bắt buộc nhập mật khẩu."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1466210176 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu này không đúng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1568315684 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu phải gồm tối thiểu " + d["0"] + " ký tự"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a911399634 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu phải chứa từ " + d["0"] + " đến " + d["1"] + " ký tự."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a510699326 = messageFormatterFn((function(  ) {
  return function(d) { return "Địa chỉ email này đã được sử dụng để tạo tài khoản trên " + d["0"] + " bằng " + d["1"] + ". Sử dụng địa chỉ email khác hoặc đăng nhập bằng tài khoản " + d["1"] + " liên kết với email này."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a428275950 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, chúng tôi không thể sử dụng Apple ID của bạn để đăng nhập. Chúng tôi đang làm việc với Apple để hỗ trợ đăng nhập với ID là số điện thoại. Hiện tại vui lòng sử dụng hình thức khác để đăng nhập."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2085036868 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi không thể tìm thấy tài khoản này."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1221952317 = messageFormatterFn((function(  ) {
  return function(d) { return "Cần nhập địa chỉ email."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1306393620 = messageFormatterFn((function(  ) {
  return function(d) { return "Đóng đăng nhập"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1819179914 = messageFormatterFn((function(  ) {
  return function(d) { return "Đóng tạo tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1098207121 = messageFormatterFn((function(  ) {
  return function(d) { return "Quay lại trang trước"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b132318856 = messageFormatterFn((function(  ) {
  return function(d) { return "Đóng cửa sổ nhập email xác thực"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b639920830 = messageFormatterFn((function(  ) {
  return function(d) { return "Đóng cửa sổ nhập mã bảo mật"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1952928908 = messageFormatterFn((function(  ) {
  return function(d) { return "Thanh toán như người dùng khách hoặc đăng nhập"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a648131862 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi là khách hàng mới"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1474573707 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn vẫn có thể tạo tài khoản sau khi thanh toán."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b509358284 = messageFormatterFn((function(  ) {
  return function(d) { return "Thanh toán như người dùng khách"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1593656552 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi là khách hàng cũ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1281539496 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập để tích lũy và sử dụng điểm khi đặt phòng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b491876863 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập và thanh toán"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1805195674 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoặc tiếp tục bằng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a755082464 = messageFormatterFn((function(  ) {
  return function(d) { return "Xin chào!"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1088436473 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập hoặc tạo tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a136732612 = messageFormatterFn((function(  ) {
  return function(d) { return "Tiếp tục"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1495296002 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi đã gửi đường link thiết lập mật khẩu tới " + d["0"] + ". Có thể mất vài phút để nhận mã xác thực. Hãy kiểm tra thư mục rác (junk hoặc spam) nếu không thấy trong hộp thư đến."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a247149643 = messageFormatterFn((function(  ) {
  return function(d) { return "Thiết lập lại mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a907666211 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu phải từ 8 ký tự trở lên."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1811728813 = messageFormatterFn((function(  ) {
  return function(d) { return "Tiếp tục với tài khoản liên kết"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1782323139 = messageFormatterFn((function(  ) {
  return function(d) { return "hoặc thiết lập mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b487204019 = messageFormatterFn((function(  ) {
  return function(d) { return "Kiểm tra hộp thư đến!"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1899533356 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi đã gửi đường link xác thực đến " + d["0"] + " để thiết lập mật khẩu tài khoản của bạn. Có thể mất vài phút để nhận mã xác thực. Hãy kiểm tra thư mục rác (junk hoặc spam) nếu không thấy trong hộp thư đến."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b773605032 = messageFormatterFn((function(  ) {
  return function(d) { return "Thiết lập mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a643760110 = messageFormatterFn((function(  ) {
  return function(d) { return "Chỉnh sửa"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1907348464 = messageFormatterFn((function(  ) {
  return function(d) { return "Có vẻ như bạn đã đặt sản phẩm với chúng tôi trước đây. Vì lý do bảo mật, chúng tôi cần xác thực địa chỉ email của bạn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a993814546 = messageFormatterFn((function(  ) {
  return function(d) { return "Sử dụng đường link xác thực đến " + d["0"] + " để hoàn tất tạo tài khoản. Có thể mất vài phút để nhận mã xác thực. Kiểm tra thư mục rác nếu như bạn không thấy trong hộp thư đến."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a25944948 = messageFormatterFn((function(  ) {
  return function(d) { return "Thông tin cá nhân về việc đi lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b658764377 = messageFormatterFn((function(  ) {
  return function(d) { return "Thông tin tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1004451795 = messageFormatterFn((function(  ) {
  return function(d) { return "Cập nhật thông tin cá nhân và thiết lập tùy chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1116367171 = messageFormatterFn((function(  ) {
  return function(d) { return "Thông tin TSA"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1501663009 = messageFormatterFn((function(  ) {
  return function(d) { return "Thêm Known Traveler Number hoặc số redress"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a102419825 = messageFormatterFn((function(  ) {
  return function(d) { return "Thông tin cá nhân"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b966200107 = messageFormatterFn((function(  ) {
  return function(d) { return "Thông tin cá nhân cơ bản để chúng tôi có thể liên hệ với bạn khi cần"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1795640428 = messageFormatterFn((function(  ) {
  return function(d) { return "Tùy chọn chuyến bay"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2138360304 = messageFormatterFn((function(  ) {
  return function(d) { return "Cài đặt để cá nhân hóa trải nghiệm của bạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1020371291 = messageFormatterFn((function(  ) {
  return function(d) { return "Chương trình thưởng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1332712713 = messageFormatterFn((function(  ) {
  return function(d) { return "Lưu chương trình khách bay thường xuyên và chương trình thành viên mà bạn tham gia"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a921481325 = messageFormatterFn((function(  ) {
  return function(d) { return "Hộ chiếu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1558727889 = messageFormatterFn((function(  ) {
  return function(d) { return "Lưu hộ chiếu để đẩy nhanh quá trình đặt phòng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b20907418 = messageFormatterFn((function(  ) {
  return function(d) { return "Quản lý thiết bị"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1965503370 = messageFormatterFn((function(  ) {
  return function(d) { return "Kiểm tra những thiết bị bạn đã đăng nhập"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2117415730 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập để xem thông tin tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1928760405 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b302265396 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, đã có lỗi phát sinh."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1659693623 = messageFormatterFn((function(  ) {
  return function(d) { return "Dường như bạn đã mất kết nối mạng. Vui lòng kiểm tra kết nối internet và thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b321381455 = messageFormatterFn((function(  ) {
  return function(d) { return "Thử lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1387426334 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang tải..."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b20921721 = messageFormatterFn((function(  ) {
  return function(d) { return "1 đêm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1722003791 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " đêm"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b43918213 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoàn tất, đã chọn 1 đêm. Lưu thay đổi và đóng lịch."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1032073155 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoàn tất, đã chọn " + d["0"] + " đêm. Lưu thay đổi và đóng lịch."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1308949696 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn ngày"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a265489705 = messageFormatterFn((function(  ) {
  return function(d) { return "Có " + d["0"] + " kết quả"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1340689633 = messageFormatterFn((function(  ) {
  return function(d) { return "Có 1 kết quả"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b39779 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b1114586147 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.a37815152 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b1084638806 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b1060445123 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.b1508481678 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a737276893 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1006304099 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b476809827 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b203756240 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.b1778865091 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b352215646 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"CN","mon":"T2","tue":"T3","wed":"T4","thu":"T5","fri":"T6","sat":"T7"}}}});
Globalize.a1096986013 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"Chủ Nhật","mon":"Thứ Hai","tue":"Thứ Ba","wed":"Thứ Tư","thu":"Thứ Năm","fri":"Thứ Sáu","sat":"Thứ Bảy"}}}});
Globalize.b156259427 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"tháng 1","2":"tháng 2","3":"tháng 3","4":"tháng 4","5":"tháng 5","6":"tháng 6","7":"tháng 7","8":"tháng 8","9":"tháng 9","10":"tháng 10","11":"tháng 11","12":"tháng 12"}}}});
Globalize.b1387428253 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a1867858896 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"}),"2":Globalize("vi-VN").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1098899697 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"thg 1","2":"thg 2","3":"thg 3","4":"thg 4","5":"thg 5","6":"thg 6","7":"thg 7","8":"thg 8","9":"thg 9","10":"thg 10","11":"thg 11","12":"thg 12"}}}});
Globalize.b313208904 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"tháng 1","2":"tháng 2","3":"tháng 3","4":"tháng 4","5":"tháng 5","6":"tháng 6","7":"tháng 7","8":"tháng 8","9":"tháng 9","10":"tháng 10","11":"tháng 11","12":"tháng 12"}}}});
Globalize.a937479677 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM, y","timeSeparator":":","months":{"M":{"4":{"1":"tháng 1","2":"tháng 2","3":"tháng 3","4":"tháng 4","5":"tháng 5","6":"tháng 6","7":"tháng 7","8":"tháng 8","9":"tháng 9","10":"tháng 10","11":"tháng 11","12":"tháng 12"}}}});
Globalize.b939650685 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"MMMM 'năm' y","timeSeparator":":","months":{"M":{"4":{"1":"tháng 1","2":"tháng 2","3":"tháng 3","4":"tháng 4","5":"tháng 5","6":"tháng 6","7":"tháng 7","8":"tháng 8","9":"tháng 9","10":"tháng 10","11":"tháng 11","12":"tháng 12"}}}});
Globalize.b938965492 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"d MMM, y","timeSeparator":":","months":{"M":{"3":{"1":"thg 1","2":"thg 2","3":"thg 3","4":"thg 4","5":"thg 5","6":"thg 6","7":"thg 7","8":"thg 8","9":"thg 9","10":"thg 10","11":"thg 11","12":"thg 12"}}}});
Globalize.a307632305 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"EEEE, d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"Chủ Nhật","mon":"Thứ Hai","tue":"Thứ Ba","wed":"Thứ Tư","thu":"Thứ Năm","fri":"Thứ Sáu","sat":"Thứ Bảy"}}},"months":{"M":{"3":{"1":"thg 1","2":"thg 2","3":"thg 3","4":"thg 4","5":"thg 5","6":"thg 6","7":"thg 7","8":"thg 8","9":"thg 9","10":"thg 10","11":"thg 11","12":"thg 12"}}}});
Globalize.b320597072 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"E, d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"CN","mon":"Th 2","tue":"Th 3","wed":"Th 4","thu":"Th 5","fri":"Th 6","sat":"Th 7"}}},"months":{"M":{"3":{"1":"thg 1","2":"thg 2","3":"thg 3","4":"thg 4","5":"thg 5","6":"thg 6","7":"thg 7","8":"thg 8","9":"thg 9","10":"thg 10","11":"thg 11","12":"thg 12"}}}});
Globalize.a378673972 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b735872396 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a1852732359 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a730278401 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b681731372 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.a306435529 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a1115990644 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b627590348 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b98096076 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a1611160967 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b1400151340 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b503389013 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a260825460 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b992419980 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b804144660 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"d"}));
Globalize.a1476451815 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1526758266 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a65504847 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b207295930 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b560936934 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b560251741 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b310098246 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.a58116679 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1992735715 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a878189347 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a1063351350 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b59102608 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a932330371 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b482945480 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.b1564914909 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a986471395 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a1515965667 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a821779958 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.a213910403 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a1302745756 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^CN/],["mon",/^T2/],["tue",/^T3/],["wed",/^T4/],["thu",/^T5/],["fri",/^T6/],["sat",/^T7/]]});
Globalize.b650743453 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["sun",/^Chủ Nhật/],["mon",/^Thứ Hai/],["thu",/^Thứ Năm/],["fri",/^Thứ Sáu/],["sat",/^Thứ Bảy/],["tue",/^Thứ Ba/],["wed",/^Thứ Tư/]]});
Globalize.b1903988893 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^tháng 10/],["11",/^tháng 11/],["12",/^tháng 12/],["1",/^tháng 1/],["2",/^tháng 2/],["3",/^tháng 3/],["4",/^tháng 4/],["5",/^tháng 5/],["6",/^tháng 6/],["7",/^tháng 7/],["8",/^tháng 8/],["9",/^tháng 9/]]});
Globalize.a1933035613 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1632054806 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1469216533 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["10",/^thg 10/],["11",/^thg 11/],["12",/^thg 12/],["1",/^thg 1/],["2",/^thg 2/],["3",/^thg 3/],["4",/^thg 4/],["5",/^thg 5/],["6",/^thg 6/],["7",/^thg 7/],["8",/^thg 8/],["9",/^thg 9/]]});
Globalize.a1679566590 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^tháng 10/],["11",/^tháng 11/],["12",/^tháng 12/],["1",/^tháng 1/],["2",/^tháng 2/],["3",/^tháng 3/],["4",/^tháng 4/],["5",/^tháng 5/],["6",/^tháng 6/],["7",/^tháng 7/],["8",/^tháng 8/],["9",/^tháng 9/]]});
Globalize.b1710989449 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM, y","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^tháng 10/],["11",/^tháng 11/],["12",/^tháng 12/],["1",/^tháng 1/],["2",/^tháng 2/],["3",/^tháng 3/],["4",/^tháng 4/],["5",/^tháng 5/],["6",/^tháng 6/],["7",/^tháng 7/],["8",/^tháng 8/],["9",/^tháng 9/]]});
Globalize.a1053124809 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM 'năm' y","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^tháng 10/],["11",/^tháng 11/],["12",/^tháng 12/],["1",/^tháng 1/],["2",/^tháng 2/],["3",/^tháng 3/],["4",/^tháng 4/],["5",/^tháng 5/],["6",/^tháng 6/],["7",/^tháng 7/],["8",/^tháng 8/],["9",/^tháng 9/]]});
Globalize.a1053810002 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM, y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["10",/^thg 10/],["11",/^thg 11/],["12",/^thg 12/],["1",/^thg 1/],["2",/^thg 2/],["3",/^thg 3/],["4",/^thg 4/],["5",/^thg 5/],["6",/^thg 6/],["7",/^thg 7/],["8",/^thg 8/],["9",/^thg 9/]]});
Globalize.a2044408747 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE, d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["sun",/^Chủ Nhật/],["mon",/^Thứ Hai/],["thu",/^Thứ Năm/],["fri",/^Thứ Sáu/],["sat",/^Thứ Bảy/],["tue",/^Thứ Ba/],["wed",/^Thứ Tư/]],"gregorian/months/format/abbreviated":[["10",/^thg 10/],["11",/^thg 11/],["12",/^thg 12/],["1",/^thg 1/],["2",/^thg 2/],["3",/^thg 3/],["4",/^thg 4/],["5",/^thg 5/],["6",/^thg 6/],["7",/^thg 7/],["8",/^thg 8/],["9",/^thg 9/]]});
Globalize.a1672178422 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E, d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["mon",/^Th 2/],["tue",/^Th 3/],["wed",/^Th 4/],["thu",/^Th 5/],["fri",/^Th 6/],["sat",/^Th 7/],["sun",/^CN/]],"gregorian/months/format/abbreviated":[["10",/^thg 10/],["11",/^thg 11/],["12",/^thg 12/],["1",/^thg 1/],["2",/^thg 2/],["3",/^thg 3/],["4",/^thg 4/],["5",/^thg 5/],["6",/^thg 6/],["7",/^thg 7/],["8",/^thg 8/],["9",/^thg 9/]]});
module.exports = Globalize;
